// extracted by mini-css-extract-plugin
module.exports = {"icon_option":"Home_icon_option__20FpC","container_home":"Home_container_home__3zxSq","container":"Home_container__1ZnZw"};